
/* injects from baggage-loader */

'use strict';

import AccountDocumentRequestsComponent from './account.document-requests.component';

const AccountDocumentRequestsPageModule = angular.module('account-document-requests-module', [
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.document-requests', {
        data: {
          title: 'Document Requests',
          navTitle: 'Document Requests'
        },
        url: '/document-requests?product?document?status?page',
        component: 'accountDocumentRequests',
        protected: true,
        // Do not reload the page when updating query string
        reloadOnSearch: false,
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          documentRequestResults: function ($transition$, Product, ProductDocument, DocumentRequest) {
            let page = $transition$.params('to')['page'];
            let query = ['status', 'product', 'document'].reduce((q, key) => {
              if ($transition$.params('to')[key]) {
                let value = $transition$.params('to')[key];
                value = (key === 'product') ? new Product({ id: value }) : value;
                q.equalTo.push({ key, value });
              }
              return q;
            }, { equalTo: [], withCount: true });
            if (parseInt(page)) query.skip = (parseInt(page) * 10) - 10;
            return DocumentRequest.fetchSome(query);
          },
          documentRequests: function (documentRequestResults) {
            return documentRequestResults.results;
          },
          collectionSize: function (documentRequestResults) {
            return documentRequestResults.count;
          },
          productList: function (Product) {
            return Product.getProductNamesList();
          },
          documents: function ($transition$, $log, Product) {
            if (!$transition$.params('to').product) {
              return [];
            }
            let product = new Product({ id: $transition$.params('to').product });
            return product.relation('documents').query()
              .limit(1000).select(['label']).find();
          }
        }
      });
  })
  .component('accountDocumentRequests', new AccountDocumentRequestsComponent());

export default AccountDocumentRequestsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/document-requests/account.document-requests.module.js